import { Icon, IconNames } from "@/App/Equities/shared/components"

export interface BottomNavigationTab {
  key: string
  icon: IconNames
  label: string
}

interface BottomNavigationProps {
  tabs: ReadonlyArray<BottomNavigationTab>
  activeTab: string
  onTabChange: (key: string) => void
}

export const BottomNavigation = ({
  tabs,
  activeTab,
  onTabChange,
}: BottomNavigationProps) => {
  return (
    <div role="tablist" className="flex w-dvw flex-row bg-primary">
      {tabs.map(({ key, icon, label }) => {
        const isActive = activeTab === key
        return (
          <button
            type="button"
            role="tab"
            aria-selected={isActive}
            key={key}
            className={`flex h-[60px] max-w-full flex-1 cursor-pointer flex-col items-center justify-center border-0 bg-secondary_subtle p-0 text-lg-semibold leading-normal ${isActive ? "text-quaternary_on-brand" : ""}`}
            onClick={() => onTabChange(key)}
          >
            <Icon
              name={icon}
              size="sm"
              color={isActive ? "text-quaternary_on-brand" : "currentColor"}
            />
            {label}
          </button>
        )
      })}
    </div>
  )
}
